/* eslint-disable camelcase */
import cropr from "../../shared/utils/cropr";
import { DesignType } from "../components/SoilTriangleDesigns";

export function getSoilOptions({ country = "NL", base = cropr.soiltype }) {
  const lst = Object.values(base).filter((b: any) => b.country === country);
  const list = lst.length
    ? lst
    : Object.values(base).filter(({ edi_code }) => edi_code.startsWith("USDA"));
  return list.map((e: any) => ({ value: e.id, label: e.name }));
}

export function getSoilTriangles({ country = "NL" }: { country: string }): Array<DesignType> {
  return country === "NL" ? ["stiboka_texture", "peat"] : ["usda_texture"];
}
